import React, { useEffect } from 'react';
import HouseBanner from '../Components/HouseBanner/HouseBanner';
import Images from '../Assets/Images/Images';
import HouseInfo from '../Components/HouseInfo/HouseInfo';
import HouseFacilities from '../Components/HouseFacilities/HouseFacilities';
import HouseLocation from '../Components/HouseLocation/HouseLocation';

const HouseOfArieTwo = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <>
      <HouseBanner
        houseNumber={2}
        imageUrl={Images.homeHouseTwo}
      />
      <HouseInfo
        image={Images.houseTwoInfo}
        carouselImages={Images.houseTwoCarousel}
        text={[
          <p>House of Arie 2 menawarkan 48 kamar lengkap dengan furnitur dengan suasana moderen dan fungsional. Kami
            menggabungkan gaya arsitektur minimalis dengan interior yang hangat dan alami untuk memberikan Anda
            akomodasi yang nyaman namun modern.</p>,
          <p>Selain itu, lingkungan yang strategis hanya 180m atau 2 menit ke FKG Dr. Moestopo dan 500m atau 5 menit ke
            Gerbang Tol Veteran. Untuk ke STP Trisakti hanya berjarak 900m atau 10 Menit.</p>,
          <p>Semua kamar di lengkapi dengan kamar mandi dalam dengan tipe kamar dan fasilitas yang berbeda-beda dimulai
            dari luas 3 meter persegi.</p>,
          <p>Area parkir yang luas cukup untuk menampung mobil dan motor. Security dan Kamera CCTV 24 Jam siap
            menambah rasa aman dan nyaman untuk penghuni House of Arie 2.</p>
        ]}
      />
      <HouseFacilities
        imageOne={Images.houseTwoFac1}
        imageTwo={Images.houseTwoFac2}
      />
      <HouseLocation
        mapUrl='https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15864.003009199201!2d106.7644129!3d-6.2636295!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9b9696c7a2fa90a5!2sHouse%20of%20Arie!5e0!3m2!1sen!2sid!4v1597990641382!5m2!1sen!2sid'
      />
    </>
  )
    ;
};

export default HouseOfArieTwo;
